import { Checkbox, Flex, FormControl } from '@chakra-ui/react';
import { Field } from 'formik';
import { KText } from '@/ui-library/components/text';
import DescriptionField from './Description';

export const Feedback = () => {
  return (
    <Flex
      border="1px solid"
      borderColor="border-color"
      p="20px"
      borderRadius="sm"
      flexDir="column"
      gap="10px"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap="12px"
      >
        <KText size="sm-medium">Feedback</KText>
        <Flex as="label" gap="12px" alignItems="center" cursor="pointer">
          <Field name="is_feedback_mandatory">
            {({ field }) => (
              <FormControl gap="6px" display="flex" alignItems="center">
                <Checkbox
                  {...field}
                  isChecked={field?.value === 'true' || field?.value === true}
                />
                <KText
                  size="sm-medium"
                  data-test-id="mark-feedback-as-mandatory"
                >
                  Mandatory
                </KText>
              </FormControl>
            )}
          </Field>
        </Flex>
      </Flex>
      <DescriptionField name="feedback_description" />
      <KText size="sm-regular">Feedback goes here</KText>
    </Flex>
  );
};
